import ubBanzai from 'ub/control/banzai-features';

const formColumnsPagesAndOverlaysEnabled = ubBanzai.features.isFormColumnsOnPagesAndOverlaysEnabled();
const ampFormSubmissionEnabled = ubBanzai.features.isAmpFormSubmissionEnabled();
const ampConversionGoalsEnabled = ubBanzai.features.isAmpConversionGoalsEnabled();

export default {
  "defaults": {

    // General Settings
    "displayName": "Page",
    "displayNameLowerCase": "page",

    "webappPayloadKey": "page",
    "webappPagesResource": "pages",
    "webappVariantsResource": "variants",
    "webappTemplatesResource": "page_templates",

    "fitWidthToPageValue": true,
    "linkTargetDefault": "_self",
    "startingBreakpoint": "desktop",

    // Variants
    "supportsMultipleVariants": true,

    // Widgets
    "allowBoxWidget": true,
    "allowBlockWidget": true,
    "allowButtonWidget": true,
    "allowCodeWidget": true,
    "allowFormWidget": true,
    "allowImageWidget": true,
    "allowSocialWidget": true,
    "allowTextWidget": true,
    "allowVideoWidget": true,

    // Page Properties
    "allowPageMetadata": true,

    // Page Sections
    "showPageHeightWarning": false,
    "sectionHeight": 200,
    "sectionCountLimit": null,
    "allowSectionBorderRadiusControls": true,
    "allowSectionBorderLocationControls": true,
    "allowSectionMargins": true,

    // General Element Properties
    "allowVisibilityToggle": true,

    // Page Root
    "allowRootTopPadding": true,
    "allowRootBackground": true,
    "showRootDisplayPositionControls": false,

    // Backgrounds
    "allowFitWidthToPage": true,
    "allowParallaxBackgrounds": true,
    "allowVideoBackgrounds": true,
    "showRootBackground": true,

    // Responsive & Mobile
    "allowAutoLayout": true,
    "allowResponsive": true,
    "allowViewportMetaTag": true,
    "allowDisablingDesktopBreakpoint": false,
    "useDesktopWidthAsCSSBreakpoint": false,
    "mobileViewEnabled": false,
    "showResponsiveControls": true,

    // Text
    "ctaifyLinks": true,
    "allowDTR": true,

    // Forms & Form Confirmation
    "allowFormRadioFields": true,
    "allowFormColumns": formColumnsPagesAndOverlaysEnabled,
    "setFormColumnsAutomatically": false,
    "rightAlignFormButtonPosition": false,
    "formTargetDefault": "",
    "formConfirmationDialogSectionHeight": 180,
    "formConfirmationText": "<h1 style=\"text-align: center;\">Thank You!</h1><p style=\"text-align: center;\">Your form has been submitted.</p>",
    "showFormBuilderPlaceholderInput": formColumnsPagesAndOverlaysEnabled,
    "showFormConfirmation": true,
    "maxFormColumns": 4,

    // Lightboxes
    "allowExternalLightboxes": true,
    "allowInternalLightboxes": true,

    // Scripts
    "showScriptManager": true,
    "allowCustomScripts": true,
    "allowCustomStyles": true,

    // Saving & Publishing
    "showPublishedURL": true,
    "allowRepublishing": true,
    "allowPreviewing": true,

    // Goals
    "showGoalsTab": true,
    "addGoalAttributeToLinks": false,
    "showExternalConversionGoals": true,

    // Tours
    "showTour": true,
    "useConvertablesMobileTour": false,

    // Popups and Overlays
    "allowButtonCloseClickAction": false,
    "allowAutoDismissEmbeddable": false,
    "showMainPageCanvasAsModal": false,
    "showSecondaryPageCanvasAsModal": true,
    "isEmbeddable": false,
    "showOverlaySEOWarning": false,
  },

  "overrides": {
    // Overlay/popup. Named 'embeddable' for legacy reasons.
    "embeddable": {

      // General Settings
      "displayName": "Popup",
      "displayNameLowerCase": "Popup", // Unlike 'page', 'Popup' should always be capitalized

      "webappPayloadKey": "embeddable",
      "webappPagesResource": "convertables",
      "webappVariantsResource": "embeddable_variants",
      "webappTemplatesResource": "embeddable_templates",

      "fitWidthToPageValue": false,
      "linkTargetDefault": "_blank",
      "formTargetDefault": "_parent",
      "startingBreakpoint": "desktop",

      // Variants
      "supportsMultipleVariants": false,

      // Widgets
      "allowSocialWidget": false,

      // Page Properties
      "allowPageMetadata": false,

      // Page Sections
      "sectionHeight": 500,
      "sectionCountLimit": null,
      "allowSectionMargins": false,

      // Page Root
      "allowRootTopPadding": false,
      "allowRootBackground": true,

      // Backgrounds
      "allowFitWidthToPage": false,
      "allowParallaxBackgrounds": false,

      // Responsive & Mobile
      "allowResponsive": false,
      "allowViewportMetaTag": false,
      "allowDisablingDesktopBreakpoint": true,
      "useDesktopWidthAsCSSBreakpoint": true,

      // Text
      "ctaifyLinks": false,
      "allowDTR": true,

      // Forms & Form Confirmation
      "showFormBuilderPlaceholderInput": formColumnsPagesAndOverlaysEnabled,
      "allowFormColumns": formColumnsPagesAndOverlaysEnabled,
      "setFormColumnsAutomatically": false,
      "rightAlignFormButtonPosition": false,

      // Lightboxes
      "allowExternalLightboxes": false,
      "allowInternalLightboxes": false,

      // Scripts
      "showScriptManager": false,

      // Saving & Publishing
      "showPublishedURL": false,
      "allowRepublishing": false,

      // Goals
      "showExternalConversionGoals": false,
      "addGoalAttributeToLinks": true,

      // Tours
      "useConvertablesMobileTour": true,

      // Popups and Overlays
      "allowButtonCloseClickAction": true,
      "showMainPageCanvasAsModal": true,
      "isEmbeddable": true,
      "showOverlaySEOWarning": true,
      "allowAutoDismissEmbeddable": true,
    },

    "stickyBar": {

      // General Settings
      "displayName": "Sticky Bar",
      "displayNameLowerCase": "Sticky Bar", // Unlike 'page', 'Sticky Bar' should always be capitalized

      "webappPayloadKey": "embeddable",
      "webappPagesResource": "convertables",
      "webappVariantsResource": "embeddable_variants",
      "webappTemplatesResource": "embeddable_templates",

      "formConfirmationDialogSectionHeight": 60,
      "formConfirmationText": "<p style=\"text-align: center;\"><strong>Thank You!</strong> Your form has been submitted.</p>",
      "fitWidthToPageValue": true,
      "linkTargetDefault": "_blank",
      "formTargetDefault": "_parent",
      "startingBreakpoint": "desktop",

      // Variants
      "supportsMultipleVariants": false,

      // Widgets
      "allowSocialWidget": false,
      "allowVideoWidget": false,

      // Page Properties
      "allowPageMetadata": false,

      // Page Sections
      "showPageHeightWarning": true,
      "sectionCountLimit": 1,
      "sectionHeight": 60,
      "allowSectionMargins": false,
      "allowSectionBorderRadiusControls": false,
      "allowSectionBorderLocationControls": false,

      // Page Root
      "allowRootTopPadding": false,
      "allowRootBackground": false,
      "showRootDisplayPositionControls": true,

      // Backgrounds
      "allowFitWidthToPage": false,
      "allowParallaxBackgrounds": false,
      "allowVideoBackgrounds": false,
      "showRootBackground": false,

      // Responsive & Mobile
      "allowAutoLayout": false,
      "allowResponsive": false,
      "allowViewportMetaTag": false,
      "allowDisablingDesktopBreakpoint": true,
      "useDesktopWidthAsCSSBreakpoint": true,

      // Text
      "ctaifyLinks": false,
      "allowDTR": true,

      // Forms & Form Confirmation
      "allowFormRadioFields": false,
      "showFormBuilderPlaceholderInput": true,
      "allowFormColumns": true,
      "setFormColumnsAutomatically": true,
      "rightAlignFormButtonPosition": true,

      // Lightboxes
      "allowExternalLightboxes": false,
      "allowInternalLightboxes": false,

      // Scripts
      "showScriptManager": false,

      // Saving & Publishing
      "showPublishedURL": false,
      "allowRepublishing": false,

      // Goals
      "showExternalConversionGoals": false,
      "addGoalAttributeToLinks": true,

      // Tours
      "useConvertablesMobileTour": true,

      // Popups and Overlays
      "allowButtonCloseClickAction": true,
      "showMainPageCanvasAsModal": false,
      "showSecondaryPageCanvasAsModal": false,
      "isEmbeddable": true,
      "allowAutoDismissEmbeddable": true,
    },

    "amp": {

      // General Settings
      "displayName": "AMP",
      "displayNameLowerCase": "amp",

      "webappPayloadKey": "amp",
      "webappPagesResource": "pages",
      "webappVariantsResource": "variants",
      "webappTemplatesResource": "page_templates",

      "startingBreakpoint": "mobile",

      // Variants
      "supportsMultipleVariants": false,

      // Widgets
      "allowSocialWidget": false,
      "allowFormWidget": ampFormSubmissionEnabled,

      // General Element Properties
      "allowVisibilityToggle": false,

      // Lightboxes
      "allowExternalLightboxes": false,
      "allowInternalLightboxes": false,

      // Text
      "allowDTR": false,

      // Forms & Form Confirmation
      "showFormConfirmation": false,
      "maxFormColumns": 1,

      // Saving & Publishing
      "allowRepublishing": false,
      "allowPreviewing": false,

      // Goals
      "showGoalsTab": ampConversionGoalsEnabled,
      "showExternalConversionGoals": false,

      // Backgrounds
      "allowParallaxBackgrounds": false,
      "allowVideoBackgrounds": false,

      // Responsive & Mobile
      "allowDisablingDesktopBreakpoint": false,
      "mobileViewEnabled": true,
      "showResponsiveControls": false,
      "allowAutoLayout": false,

      // Tours
      "showTour": false,

    }
  }
};



// WEBPACK FOOTER //
// ./src/config/content-types.js